export const isAllow = (roles, userRole) => {
  return roles.includes(userRole)
}

export default {
  isAllow,
}
